import * as tslib_1 from "tslib";
import { env } from '@ivy/fts/envInfo/envInfo';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let TitleBar = class TitleBar extends Vue {
    constructor() {
        super(...arguments);
        this.opacity = 0;
        this.scrollTop = 0;
    }
    change(val) {
        if (this.isColloction && this.isOpacity === undefined) {
            this.isOpacity = true;
        }
        if (!this.isOpacity) {
            this.opacity = 1;
        }
    }
    mounted() {
        if (this.isColloction && this.isOpacity === undefined) {
            this.isOpacity = true;
        }
        if (this.isOpacity) {
            window.addEventListener('scroll', this.scrollEvent);
        }
        else {
            this.opacity = 1;
        }
    }
    destroyed() {
        if (this.isOpacity) {
            window.removeEventListener('scroll', this.scrollEvent);
        }
    }
    scrollEvent() {
        this.scrollTop =
            window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
        if (this.isColloction) {
            this.scrollTop > this.navbarHeight + 84
                ? (this.opacity = 1)
                : (this.opacity = this.scrollTop * 0.005);
        }
        else {
            this.scrollTop > 85
                ? (this.opacity = 1)
                : (this.opacity = this.scrollTop * 0.015);
        }
    }
    async back() {
        let list = ['拼团规则', '更多拼团', '参团详情'];
        if (this.useRouterBack || list.indexOf(this.title) > -1) {
            this.$router.go(-1);
        }
        else {
            await env.init();
            await this.$emit('intellect-statistics', 'stay');
            await env.back();
        }
    }
    async share() {
        await env.init();
        let options = {};
        if (this.options) {
            options = this.options;
        }
        else if (this.spu) {
            options = {
                title: `${this.spu.title}`,
                content: this.spu.remark,
                url: `${window.location.origin}/goods/goodsView?spuId=${this.$route.query.spuId}`,
                pic_url: this.spu.cover,
            };
        }
        await env.share(options);
    }
};
tslib_1.__decorate([
    Prop()
], TitleBar.prototype, "spu", void 0);
tslib_1.__decorate([
    Prop()
], TitleBar.prototype, "navbarHeight", void 0);
tslib_1.__decorate([
    Prop()
], TitleBar.prototype, "title", void 0);
tslib_1.__decorate([
    Prop()
], TitleBar.prototype, "isOpacity", void 0);
tslib_1.__decorate([
    Prop()
], TitleBar.prototype, "options", void 0);
tslib_1.__decorate([
    Prop()
], TitleBar.prototype, "listen", void 0);
tslib_1.__decorate([
    Prop()
], TitleBar.prototype, "spuId", void 0);
tslib_1.__decorate([
    Prop()
], TitleBar.prototype, "isColloction", void 0);
tslib_1.__decorate([
    Prop()
], TitleBar.prototype, "bgcolor", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], TitleBar.prototype, "useRouterBack", void 0);
tslib_1.__decorate([
    Watch('isOpacity')
], TitleBar.prototype, "change", null);
TitleBar = tslib_1.__decorate([
    Component({
        components: {},
    })
], TitleBar);
export default TitleBar;
